module.exports = __webpack_public_path__ + "img/Taewook Kang.1a42e969.jpg";